// extracted by mini-css-extract-plugin
module.exports = {"controlsContainer":"-search-terms-graph-controlsContainer-1hZp7L-","graphsContainer":"-search-terms-graph-graphsContainer-SoKkIX-"};